import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import VideoTestimonials from './VideoTestimonials';
import { websiteDevelopmentOmanConfig } from './servicePageConfigs';

const WebsiteDevelopmentOman = () => (
  <ServicePageTemplate {...websiteDevelopmentOmanConfig}>
    <VideoTestimonials />
  </ServicePageTemplate>
);

export default WebsiteDevelopmentOman;
